import React from 'react';
import { EmailBodySkeleton } from './EmailBodySkeleton';
import { SkeletonBar } from '../../ui/Skeleton/SkeletonBar';
import { SkeletonLine } from '../../ui/Skeleton/SkeletonLine';

// Mirrors the email form: the same bordered card, one divided row per field, then the body block, and
// the confirmation box beneath it.
export const EmailFormSkeleton: React.FC = () => (
    <div data-testid="email-form-skeleton" role="status" aria-busy="true" className="flex flex-col gap-xl">
        <div className="rounded-lg border border-line-subtle bg-primary-50 shadow-weak overflow-hidden divide-y divide-line-subtle">
            {['w-2/3', 'w-1/2', 'w-3/4', 'w-1/3'].map(width => (
                <div key={width} className="flex items-center gap-s px-xl py-m">
                    <SkeletonBar className="h-3 w-14 shrink-0" />
                    <SkeletonBar className={`h-5 ${width}`} />
                </div>
            ))}
            <div className="px-xl py-m">
                <EmailBodySkeleton />
            </div>
        </div>
        <div className="flex items-start gap-s px-m py-l rounded-lg bg-surface-secondary">
            <div className="flex h-lh shrink-0 items-center text-xs">
                <SkeletonBar className="size-4.75" />
            </div>
            <div className="flex flex-1 flex-col">
                <SkeletonLine lineClassName="text-xs" className="w-full" />
                <SkeletonLine lineClassName="text-xs" className="w-1/3" />
            </div>
        </div>
    </div>
);
